// extracted by mini-css-extract-plugin
export default {"snackbar":"Toast_snackbar__97PjY","alert":"Toast_alert__gVCJQ","slideDown":"Toast_slideDown__kBFhq"};